import { useQuery } from '@edreamsodigeo/frontend-api-client';
import { GET_TRIP_INFO_MODIFICATION } from "../queries/index";
const useGetTripInfoModification = ({
  token
}) => {
  return useQuery(GET_TRIP_INFO_MODIFICATION, {
    variables: {
      token
    }
  });
};
export default useGetTripInfoModification;